import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFolder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M14.8125 6.9375C14.625 6.75 14.3438 6.5625 14.0625 6.5625H3.75C3.375 6.5625 3 6.75 2.90625 7.125L0.0937538 13.6875C-0.0937462 14.25 0.0937538 15 0.937504 15H11.25C11.625 15 12 14.8125 12.0938 14.4375L14.9063 7.875C15.0938 7.59375 15 7.21875 14.8125 6.9375Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M1.125 6.375C1.59375 5.34375 2.625 4.6875 3.75 4.6875H12.1875V2.8125C12.1875 2.25 11.8125 1.875 11.25 1.875H6L4.40625 0.28125C4.21875 0.09375 4.03125 0 3.75 0H0.9375C0.375 0 0 0.375 0 0.9375V9.09375L1.125 6.375Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white"
		})
	}) })]
});
export default SvgIconFolder;
